import * as React from "react";
import { ChakraProvider, Box, Heading, Text } from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export function Terms() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("terms.metaTitle")}</title>
        <meta
          name="description"
          content={t("terms.metaDescription")}
        />
      </Helmet>
      <ChakraProvider>
        <Box
            pt={"20px"}
            pb={8}
            textAlign="justify"
            margin={"auto"}
            width="80%"
            maxWidth={"1100px"}
          >
            <Heading
              fontFamily={"Oswald"}
              fontWeight={500}
              fontSize={{ base: "4xl", sm: "4xl", md: "5xl" }}
              lineHeight={"110%"}
              color={"gray.800"}
              textAlign={"center"}
              mt={"20px"}
              mb={2}
            >
              {t("terms.headingPrefix")}{" "}
              <Text as={"span"} color={"blue.500"}>
                {t("terms.headingEmphasis")}
              </Text>
            </Heading>
            <Box mt={3}>
              <Text
                textAlign="left"
                fontFamily={"Oswald"}
                fontWeight={500}
                color="blue.400"
                mb={2}
                mt={5}
              >
                {t("terms.sections.intro.title")}
              </Text>
              <Text mb={2}>
              {t("terms.sections.intro.body")}

              </Text>

              <Text
                textAlign="left"
                fontFamily={"Oswald"}
                fontWeight={500}
                color="blue.400"
                mb={2}
                mt={5}
              >
                {t("terms.sections.used.title")}
              </Text>
              <Text mb={2}>
              {t("terms.sections.used.body")}
              </Text>
              <Box ml={"40px"} mb={4}>
                <ul>
                  <li>- {t("terms.sections.used.session.title")}</li>
                  <Text mb={2}>
                    {t("terms.sections.used.session.body")}
                  </Text>
                  <li>
                    - {t("terms.sections.used.security.title")}
                  </li>
                  <Text mb={2}>
                  {t("terms.sections.used.security.body")}
                  </Text>
                </ul>
              </Box>



                <Text
                textAlign="left"
                fontFamily={"Oswald"}
                fontWeight={500}
                color="blue.400"
                mb={2}
                mt={5}
              >
                {t("terms.sections.manage.title")}
              </Text>
              <Text mb={2}>
              {t("terms.sections.manage.body")}
              </Text>
              <Box ml={"40px"} mb={4} textAlign="left">
                <ul>
                  <li>
                    - {t("terms.sections.manage.browsers.chrome")}: {" "}
                    <a href="https://support.google.com/chrome/answer/95647">
                      https://support.google.com/chrome/answer/95647
                    </a>
                  </li>
                  <li>
                    - {t("terms.sections.manage.browsers.firefox")}: {" "}
                    <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias">
                      https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias
                    </a>
                  </li>
                  <li>
                    - {t("terms.sections.manage.browsers.safari")}: {" "}
                    <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac">
                      https://support.apple.com/es-es/guide/safari/sfri11471/mac
                    </a>
                  </li>
                  <li>
                    - {t("terms.sections.manage.browsers.edge")}: {" "}
                    <a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09">
                      https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09
                    </a>
                  </li>
                </ul>
              </Box>

              <Text
                textAlign="left"
                fontFamily={"Oswald"}
                fontWeight={500}
                color="blue.400"
                mb={2}
                mt={5}
              >
                {t("terms.sections.privacy.title")}
              </Text>
              <Text mb={2}>
              {t("terms.sections.privacy.body")}

              </Text>
              <Text
                textAlign="left"
                fontFamily={"Oswald"}
                fontWeight={500}
                color="blue.400"
                mb={2}
                mt={5}
              >
                {t("terms.sections.contact.title")}
              </Text>
              <Text mb={2}>
              {t("terms.sections.contact.body")}
              </Text>
            </Box>
          </Box>
      </ChakraProvider>
    </>
  );
}

export default Terms;
